var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBambora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3480.707,
    height: 621.093,
    viewBox: "0 0 2610.53 465.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask_a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1670 123h353v342.82h-353Zm0 0",
    fill: "white",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2252 123h358.53v340H2252Zm0 0",
    fill: "white",
    stroke: "none"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M251.01 294.2a77.05 77.05 0 0 0-75.88-80.56A86.4 86.4 0 0 0 107.41 244v100.4a86.4 86.4 0 0 0 67.72 30.36c44.37 0 75.88-35.03 75.88-80.56m106.25 0c0 96.9-73.56 169.3-161.12 169.3a165 165 0 0 1-88.73-24.53A424 424 0 0 1 0 455.32V16.34A424 424 0 0 0 107.41 0v150.6a156.5 156.5 0 0 1 88.73-25.68c87.56 0 161.12 72.38 161.12 169.28m1197.84 0a77.05 77.05 0 0 0-75.88-80.56 85.2 85.2 0 0 0-67.7 30.36v100.4a85.2 85.2 0 0 0 67.7 30.36c44.37 0 75.89-35.03 75.89-80.56m106.25 0c0 96.9-73.55 169.3-161.11 169.3a164.6 164.6 0 0 1-88.73-24.53 424 424 0 0 1-107.4 16.35V16.34A424 424 0 0 0 1411.5 0v150.6a156.5 156.5 0 0 1 88.73-25.68c87.56 0 161.11 72.38 161.11 169.28",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#8957b1",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1919.37 294.2c0-42.03-29.19-77.06-72.39-77.06a73.55 73.55 0 0 0-73.54 77.06c0 43.2 29.18 78.23 73.55 78.23s72.38-35.03 72.38-78.23m102.74-1.16c0 99.23-73.55 172.78-176.29 172.78s-175.13-73.55-175.13-172.78 73.56-169.3 175.13-169.3c101.57.01 176.29 72.4 176.29 169.3",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#8957b1",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2143.53 131.92v33.86a165.8 165.8 0 0 1 112.08-39.7v102.74c-52.54 2.34-86.4 16.35-112.08 42.04v184.46h-107.4V148.27a424 424 0 0 0 107.4-16.35M854.6 150.6a439 439 0 0 1-108.57-16.34v321.06h108.58V248.68c16.34-21.02 32.7-29.2 49.03-29.2 35.03 0 58.38 22.19 58.38 67.72v168.13h107.41V270.86q.3-12.3-1.17-24.52a63 63 0 0 1 50.2-26.85c35.03 0 57.21 22.19 57.21 67.72v168.12h109.75V270.86c0-92.23-58.38-149.44-135.43-149.44a155.3 155.3 0 0 0-114.42 43.2 129.6 129.6 0 0 0-100.4-43.2 113.2 113.2 0 0 0-80.56 29.18M616.44 343.24v-100.4a82.9 82.9 0 0 0-67.71-30.36 77.06 77.06 0 0 0-75.89 80.56 77.05 77.05 0 0 0 73.46 80.48q1.21.06 2.43.08a82.9 82.9 0 0 0 67.71-30.36m108.58 112.08a400 400 0 0 1-108.58-17.52 164.6 164.6 0 0 1-88.73 24.52c-87.56 0-161.11-73.55-161.11-169.28s73.55-169.3 161.11-169.3a164.6 164.6 0 0 1 88.73 24.53 439 439 0 0 0 108.58-16.35z",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#8957b1",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2501.95 343.24v-100.4a82.9 82.9 0 0 0-67.71-30.36 80.56 80.56 0 0 0 0 161.12 82.9 82.9 0 0 0 67.7-30.36m108.58 112.08a400 400 0 0 1-108.58-17.52 162.3 162.3 0 0 1-88.73 24.52c-87.56 0-161.12-73.55-161.12-169.28s73.56-169.3 161.12-169.3a162.3 162.3 0 0 1 88.73 24.53 439 439 0 0 0 108.58-16.35z",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#8957b1",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBambora);
export default __webpack_public_path__ + "static/media/bambora.e343a9aee97093c8d964a79715dde84f.svg";
export { ForwardRef as ReactComponent };